import type { Person, PersonImage } from '../types';

const image_path = '/images/people/';
const image_res = [512, 1024];
const image_res_avif = [853];

export const info_url = 'https://www.marcheingol.it/soggetto/';

export function usePersonDisplay() {
  function image_urls(image?: PersonImage | null) {
    if (image == null) return image_path + 'empty.svg';
    if (image.format === 'avif') {
      return image_res_avif
        .map((res) => image_path + res + '/' + image.id + '.avif ' + res + 'w')
        .join(',');
    }
    return image_res
      .map((res) => image_path + res + '/' + image.id + '.jpg ' + res + 'w')
      .join(',');
  }

  function image_url(image?: PersonImage | null) {
    if (image == null) return image_path + 'empty.svg';
    if (image.format === 'avif') return image_path + image_res_avif[0] + '/' + image.id + '.avif';
    return image_path + image_res[0] + '/' + image.id + '.jpg';
  }

  function person_name(person?: Person | null) {
    if (person == null) return '';
    return person.last_name + ' ' + person.first_name;
  }

  return { image_urls, image_url, person_name };
}
